import CustomQuestionAnswer from 'models/common/form/questionAnswer/CustomQuestionAnswer';

export default class CustomQuestionAnswerService {
	toModel(answer) {
		return new CustomQuestionAnswer(answer);
	}
}
